module.exports = __webpack_public_path__ + "media/images/ceremony/plans/2/estimate_1-9251377518275ee845a8f5301a96100e.jpg";